import { useState } from 'react';
import axios from 'axios';
import { Button, Modal, FileInput, Spinner, TextInput, Label } from 'flowbite-react';
import { FilePlus } from 'lucide-react';

const BatchUpload = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [provider, setProvider] = useState('');

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && file.type !== 'text/csv') {
      setError('Seuls les fichiers CSV sont autorisés');
      return;
    }
    setSelectedFile(file);
    setError('');
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    if (!provider.trim()) {
      setError('Le nom du fournisseur est requis');
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append('csvFile', selectedFile);
    formData.append('provider', provider.trim());

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}upload-batch`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true
      });

      if (response.status === 202) {
        setShowModal(false);
        setSelectedFile(null);
        setProvider('');
      }
    } catch (error) {
      setError(error.response?.data?.message || 'Erreur lors du téléchargement');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Button
        color={'dark'}
        onClick={() => setShowModal(true)}
        size="xs"
        pill
        className='flex items-center'
        title='Télécharger un fichier CSV'
      >
        <FilePlus size={18} />
        
      </Button>

      <Modal
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setSelectedFile(null);
          setProvider('');
          setError('');
        }}
        dismissible
      >
        <Modal.Header>
          Téléchargement de fichier CSV
        </Modal.Header>
        <Modal.Body>
          <div className="space-y-6">
            <div>
              <Label htmlFor="provider" value="Nom du fournisseur" required />
              <TextInput
                id="provider"
                type="text"
                placeholder="Entrez le nom du fournisseur"
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
                required
              />
            </div>

            <FileInput
              accept=".csv"
              onChange={handleFileSelect}
              helperText="Taille maximale du fichier: 50MB"
            />

            {error && (
              <div className="text-red-500 text-sm mt-2">
                {error}
              </div>
            )}

            {selectedFile && (
              <div className="p-4 bg-gray-50 rounded-lg">
                <h4 className="font-medium">Détails du fichier:</h4>
                <p>Nom: {selectedFile.name}</p>
                <p>Taille: {(selectedFile.size / 1024 / 1024).toFixed(2)} MB</p>
                <p>Type: {selectedFile.type}</p>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-end gap-4">
            <Button
              color="gray"
              onClick={() => {
                setShowModal(false);
                setSelectedFile(null);
                setProvider('');
              }}
            >
              Annuler
            </Button>
            <Button
              color={'dark'}
              onClick={handleUpload}
              disabled={!selectedFile || !provider.trim() || isLoading}
            >
              {isLoading ? (
                <>
                  <Spinner size="sm" className="mr-2" />
                  Traitement en cours...
                </>
              ) : (
                'Confirmer le téléchargement'
              )}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BatchUpload;